import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { DUMMY_ORDER } from "./lib";
import { type OrderConfirmation } from "./types";

const reducer = (state: OrderConfirmation.State, action: ReduxAction<any>): OrderConfirmation.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { orderSummary } = action.data as InitSuccessActionData;
      return {
        ...state,
        orderSummary,
        status: "Ready"
      };
    }

    case Actions.DownloadInvoiceBegin: {
      return {
        ...state,
        status: "Downloading"
      };
    }
    case Actions.DownloadInvoiceFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.DownloadInvoiceSuccess: {
      return {
        ...state,
        status: "Ready"
      };
    }

    default:
      return state;
  }
};

export const defaultState: OrderConfirmation.State = {
  error: null,
  id: "",
  isAddCommentVisible: false,
  status: "None",
  orderSummary: null
};
export const previewState: OrderConfirmation.State = {
  error: null,
  id: "",
  isAddCommentVisible: false,
  status: "Ready",
  orderSummary: DUMMY_ORDER
};
export default wrapReducer({ defaultState, reducer, previewState });
